export const EDIT_TODAY = 'EDIT_TODAY';